<ng-container *ngIf="control$ | async"></ng-container>
<ng-container *ngIf="form$ | async"></ng-container>

<!-- used to trick browsers into autofilling these inputs instead of the actual username and password inputs -->
<input
  style="display: none"
  type="password"
  name="username"
  autocomplete="username"
/>
<input
  style="display: none"
  type="password"
  name="old password"
  autocomplete="password"
/>
<input
  style="display: none"
  type="password"
  name="password"
  autocomplete="new-password"
/>

<div class="app-input-container">
  <div style="width: 100%; max-width: 100%">
    <label *ngIf="label" class="app-label"
      >{{ label }}
      <ng-container *ngIf="isRequired">*</ng-container>
      <i
        style="padding-left: 5px"
        tooltipPosition="top"
        pTooltip="{{ tooltip }}"
        *ngIf="tooltip"
        class="fa-solid fa-circle-question text-link-color"
      ></i>
    </label>
    <div class="app-input-field-wrapper">
      <div *ngIf="isDisabled" class="app-input-field-disabled-overlay"></div>
      <i
        *ngIf="showErrorAsTooltip && errorMessage"
        tooltipStyleClass="text-transform-capitalize"
        style="position: absolute; right: 3px; top: 3px; z-index: 3;text-transform: capitalize;"
        tooltipPosition="left"
        pTooltip="{{ errorMessage }}"
        class="fa-solid fa-circle-exclamation error-color"
      ></i>
      <p-inputgroup tooltipPosition="top">
        <input
          [type]="showHiddenInput || !hideInput ? 'text' : 'password'"
          [ngClass]="{
            'input-field-error': error && (control.dirty || control.touched)
          }"
          class="input-field"
          pInputText
          fluid
          [formControl]="control"
          [attr.readonly]="readonlyAttr ? '' : null"
          [placeholder]="placeholder || label || ''"
          (keydown.enter)="enterKey.emit($event)"
        />
        <p-inputgroup-addon *ngIf="hideInput">
          <p-button
            severity="contrast"
            variant="text"
            (click)="showHiddenInput = !showHiddenInput"
            type="button"
          >
            <i class="fa-solid fa-eye" *ngIf="showHiddenInput"></i>
            <i class="fa-thin fa-eye" *ngIf="!showHiddenInput"></i>
          </p-button>
        </p-inputgroup-addon>
        <p-inputgroup-addon *ngIf="showClearButton && control?.value">
          <p-button
            [variant]="'text'"
            severity="contrast"
            (click)="clearInput()"
            type="button"
            tooltipPosition="top">
            <i class="fa-thin fa-xmark"></i>
          </p-button>
        </p-inputgroup-addon>
        <p-inputgroup-addon *ngIf="showSearchIcon">
          <p-button
            [variant]="'text'"
            severity="contrast"
            type="button">
            <i class="fa-thin fa-magnifying-glass"></i>
          </p-button>
        </p-inputgroup-addon>
      </p-inputgroup>
    </div>
  </div>
  <div class="input-error-content-wrapper" *ngIf="!hideErrorContent">
    <span class="input-error-color input input-error-content error" *ngIf="error">
      <i class="fa-solid fa-triangle-exclamation"></i>
      {{ errorMessage }}
    </span>
  </div>
</div>
